import React, { useState } from 'react';
import { Card, Form, Button, Space, message, Select, Spin, Modal, Typography, notification } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { InvoiceType } from '../../appContants';
import { usePaymentMethod } from '../../hooks/usePaymentMethod';
import { getInvoiceTypeText } from '../../utils/clinic';

const { Text } = Typography;

const PaymentSettings = () => {
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();
  const [isEditing, setIsEditing] = useState(false);
  const { selectedLocation: currentLocation, loading, updatePaymentMethod } = usePaymentMethod();
  const selectedPaymentMethod = Form.useWatch('paymentMethod', form);

  const handleSave = async (values) => {
    const success = await updatePaymentMethod(currentLocation?.clinicLocationId, values);
    console.log("success : ", success);
    if (success) {
      notification.success({message: 'Payment method updated successfully!'});
      setIsEditing(false);
    } else {
      notification.error({message: 'Failed to update payment method'});
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
    form.setFieldsValue({
      paymentMethod: currentLocation?.paymentMethod
    });
  };



  return (
    <div className="row">
      <div className="col-md-12">
        <Card
          extra={
            !isEditing && (
              <Button
                id="edit-payment-btn"
                type="primary"
                icon={<EditOutlined />}
                onClick={handleEdit}
              >
                Edit
              </Button>
            )
          }
        >
          {loading ? (
            <div className="text-center py-4">
              <Spin size="large" />
            </div>
          ) : !isEditing ? (
            <div className="payment-method-display">
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <strong>Payment Method:</strong>
                    <div className="text-muted mt-1">
                      {getInvoiceTypeText(currentLocation?.paymentMethod)}
                    </div>
                  </div>
                  {currentLocation?.paymentMethod === InvoiceType.PAY_AS_YOU_GO && (
                    <Card size="small" style={{ background: '#fff2f0', borderColor: '#ffccc7' }}>
                      <Text type="danger">
                        Note: Service amounts are increased by $5 for Pay as you go.
                      </Text>
                    </Card>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <>
              <Form
                form={form}
                layout="vertical"
                onFinish={handleSave}
                initialValues={{
                  paymentMethod: InvoiceType.MONTHLY
                }}
              >
                <div className="row">
                  <div className="col-md-4 col-sm-6 col-xs-12">
                    <Form.Item
                      name="paymentMethod"
                      label="Payment Method"
                      rules={[{ required: true, message: 'Please select payment' }]}
                    >
                      <Select placeholder="Select payment method"
                        onChange={async (value) => {
                          if (value === InvoiceType.PAY_AS_YOU_GO) {
                            const confirmStatus = await modal.confirm({
                              title: 'Alert',
                              content: (
                                <Space direction="vertical" size="small">
                                  <Text>
                                    By changing the payment method to <b>Pay As You Go</b>, a
                                    new invoice will be created for any cases in the current
                                    month!
                                  </Text>
                                  <Text type="danger">
                                    Note: Service amounts are increased by $5 for Pay as you go.
                                  </Text>
                                </Space>
                              ),
                              okText: 'Continue',
                              cancelText: 'Discard',
                            });
                            if (!confirmStatus) {
                              form?.setFieldValue(
                                'paymentMethod',
                                InvoiceType.MONTHLY
                              );
                              message.success(<Text>Switched back to <b>Monthly</b> payment method!</Text>);
                            }
                          }
                        }}>
                        <Select.Option value={InvoiceType.MONTHLY}>{getInvoiceTypeText(InvoiceType.MONTHLY)}</Select.Option>
                        <Select.Option value={InvoiceType.PAY_AS_YOU_GO}>{getInvoiceTypeText(InvoiceType.PAY_AS_YOU_GO)}</Select.Option>
                      </Select>
                    </Form.Item>
                    {selectedPaymentMethod === InvoiceType.PAY_AS_YOU_GO && (
                      <Card size="small" className="mb-3" style={{ background: '#fff2f0', borderColor: '#ffccc7' }}>
                        <Text type="danger">
                          Note: Service amounts are increased by $5 for Pay as you go.
                        </Text>
                      </Card>
                    )}
                  </div>
                </div>
                <Form.Item>
                  <Space>
                    <Button type="primary" htmlType="submit">
                      Save Changes
                    </Button>
                    <Button onClick={() => setIsEditing(false)}>
                      Cancel
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
              {contextHolder}
            </>
          )}
        </Card>
      </div>
    </div>
  );
};

export default PaymentSettings;